<template>
  <div>
    <span v-if="title" class="mr-2">{{ title }}</span>
    <v-badge v-if="badge"
      inline
      :color="color"
      text-color="white"
      :content="badgeText"
      style="top: 27%;position: absolute;"
    >
    </v-badge>
  </div>
</template>

<script>
  export default {
    props:{
      title:{
        type:String
      },
      badge:{
        type:Number
      },
      padding:{
        type:Number,
        default:10
      },
      color:{
        type:String,
        default:'secondary'
      }
    },
    computed:{
      badgeText(){
        return (this.badge>99)?'99+':this.badge;
      }
    },
    data: () => ({
      //:style="`padding:${padding}px;`"
    }),
  }
</script>
